import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import {
  SURGERY_STATUS,
  SURGERY_STATUS_LABELS,
  PATHWAY,
  PATHWAY_LABELS,
} from '../shared/constants';
import Form from 'react-bootstrap/Form';
import TextField from '../../Utils/FormInputs/TextField';
import Label from '../../Utils/FormInputs/Label';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '12px 16px',
    marginBottom: 16,
  },
  filterRow: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 12,
  },
  filterField: {
    minWidth: 150,
    [theme.breakpoints.down('sm')]: {
      minWidth: '100%',
    },
  },
  dateField: {
    minWidth: 160,
    [theme.breakpoints.down('sm')]: {
      minWidth: '100%',
    },
  },
  searchField: {
    minWidth: 200,
    flex: 1,
    [theme.breakpoints.down('sm')]: {
      minWidth: '100%',
    },
  },
  clearBtn: {
    marginLeft: 'auto',
    whiteSpace: 'nowrap',
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
      width: '100%',
    },
  },
}));

const STATUS_OPTIONS = [
  { value: '', label: 'All Statuses' },
  { value: SURGERY_STATUS.PENDING, label: SURGERY_STATUS_LABELS[SURGERY_STATUS.PENDING] },
  { value: SURGERY_STATUS.STARTED, label: SURGERY_STATUS_LABELS[SURGERY_STATUS.STARTED] },
  { value: SURGERY_STATUS.COMPLETED, label: SURGERY_STATUS_LABELS[SURGERY_STATUS.COMPLETED] },
  { value: SURGERY_STATUS.CANCELLED, label: SURGERY_STATUS_LABELS[SURGERY_STATUS.CANCELLED] },
];

const PATHWAY_OPTIONS = [
  { value: '', label: 'All Pathways' },
  { value: PATHWAY.OUTPATIENT, label: PATHWAY_LABELS[PATHWAY.OUTPATIENT] },
  { value: PATHWAY.INPATIENT, label: PATHWAY_LABELS[PATHWAY.INPATIENT] },
];

const CLASS_OPTIONS = [
  { value: '', label: 'All Classes' },
  { value: 'minor', label: 'Minor' },
  { value: 'major', label: 'Major' },
];

const SurgeryFilters = ({ filters, onFilterChange, onClear }) => {
  const classes = useStyles();

  const handleChange = (field) => (e) => {
    onFilterChange(field, e.target.value);
  };

  return (
    <Paper className={classes.root} elevation={1}>
      <Grid container spacing={2} alignItems="center">
        {/* Status */}
        <Grid item>
          <Form.Group>
            <Label name="Status" />
            <TextField
              as="select"
              value={filters.status !== undefined ? filters.status : ''}
              onChange={handleChange('status')}
            >
              {STATUS_OPTIONS.map((opt) => (
                <option key={String(opt.value)} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </TextField>
          </Form.Group>
        </Grid>

        {/* Pathway */}
        <Grid item>
          <Form.Group>
            <Label name="Pathway" />
            <TextField
              as="select"
              value={filters.pathway || ''}
              onChange={handleChange('pathway')}
            >
              {PATHWAY_OPTIONS.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </TextField>
          </Form.Group>
        </Grid>

        {/* Operation Class */}
        <Grid item>
          <Form.Group>
            <Label name="Operation Class" />
            <TextField
              as="select"
              value={filters.operation_class || ''}
              onChange={handleChange('operation_class')}
            >
              {CLASS_OPTIONS.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </TextField>
          </Form.Group>
        </Grid>

        {/* Date From */}
        <Grid item>
          <Form.Group>
            <Label name="From" />
            <TextField
              type="date"
              value={filters.date_from || ''}
              onChange={handleChange('date_from')}
            />
          </Form.Group>
        </Grid>

        {/* Date To */}
        <Grid item>
          <Form.Group>
            <Label name="To" />
            <TextField
              type="date"
              value={filters.date_to || ''}
              onChange={handleChange('date_to')}
            />
          </Form.Group>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default SurgeryFilters;
